
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiHydraulic09Off as ObiHydraulic09OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-hydraulic-09-off.js';
 
 
 

 
 export const ObiHydraulic09Off = createComponent({
   react: React,
   tagName: 'obi-hydraulic-09-off',
   elementClass: ObiHydraulic09OffElement,
   events: {
     
   }
  });
 
 